import issuesSerializer from "./issues";
function mapValues(obj, mapper) {
  const ret = {};
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    ret[key] = mapper(obj[key]);
  }
  return ret;
}
export default {
  fromServer: ({ annotations, punch_lists }) => ({
    annotations,
    punch_lists: mapValues(punch_lists, issuesSerializer.fromCACA),
  }),
};
